'use client'

import { User } from '@auth0/auth0-react'

const ADMIN_COMPANY_SELECTION = 'nriched-admin-company'

/**
 * Reads the stored companyId from localStorage for a given user
 */
export const readCompanyFromLocalStorage = (user: User | undefined): number | undefined => {
  if (!user?.email) return undefined

  const storedCompanyKey = localStorage.getItem(ADMIN_COMPANY_SELECTION)
  if (storedCompanyKey) {
    const [email, compId] = storedCompanyKey.split('>>')
    if (email === user.email) {
      console.log('[localStorage] Restoring companyId from localStorage:', compId)
      return Number(compId)
    }
  }
  return undefined
}

/**
 * Writes the companyId to localStorage for a given user
 */
export const writeCompanyToLocalStorage = (user: User | undefined, companyId: number | undefined): void => {
  if (user?.email && companyId) {
    const storageValue = `${user.email}>>${companyId}`
    console.log('[localStorage] Saving companyId to localStorage:', storageValue)
    localStorage.setItem(ADMIN_COMPANY_SELECTION, storageValue)
  }
}
